import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { colourToColourObjectType } from "../../utils/ColourGenerators/ColourToColourObjectType";

export interface Colour {
  value: {
    name?: string;
    hex: string;
    rgb: {
      r: number;
      g: number;
      b: number;
    };
  }[];

  category: string;
}
export interface Gradient {
  name?: string;
  valueOne: {
    hex: string;
    rgb: {
      r: number;
      g: number;
      b: number;
    };
  };
  valueTwo: {
    name?: string;
    hex: string;
    rgb: {
      r: number;
      g: number;
      b: number;
    };
  }[];
  angle: number;
  gradients: { linearGradient: string }[];
  category: string;
}

export interface MainColor {
  value: {
    name?: string;
    hex: string;
    rgb: {
      r: number;
      g: number;
      b: number;
    };
  };

  category: string;
}
export interface ColoursState extends MainColor {
  //first we'll have the main brand color information which contains the hex, rgb, and name of the color
  associateColours: Colour[];
  associateGradients?: Gradient[] | [];
}

const initialColoursState: Colour[] = [];

export const colorsSlice = createSlice({
  name: "colors",
  initialState: initialColoursState,
  reducers: {
    addColor(state, action: PayloadAction<any>) {
      console.log(action.payload.category);
      state.push({
        name: `Colour - ${state.length + 1}`,
        ...action.payload,
      });
      //TODO yet to be completed
    },
    addAllAssociateColours: (
      state,
      action: PayloadAction<{
        hex: string;
        category: string;
        allcolor: any[];
        index: number;
      }>
    ) => {
      //@ts-ignore
      state[action.payload.index] = colourToColourObjectType(
        action.payload.hex,
        action.payload.category,
        action.payload.category,
        action.payload.allcolor
      );
    },
    addAllGradients: (
      state,
      action: PayloadAction<{ index: number; allgradients: any[] }>
    ) => {
      //@ts-ignore
      state[action.payload.index].associateGradients = [
        ...action.payload.allgradients,
      ];
    },
    addSingleAssociateGradients: (
      state,
      action: PayloadAction<{ mainColourName: string; colour: Colour }>
    ) => {
      state.forEach((e: any) => {
        if (e.name === action.payload.mainColourName)
          e.associateColours.push(action.payload.colour);
      });
    },
    resetColoursAndGradients: (state: any) => {
      state.forEach((e: any, index: any) => {
        state[index].associateColours = [];
        state[index].associateGradients = [];
      });
    },
    removeIndexFromState: (state, action: PayloadAction<number>) => {
      state.splice(action.payload, 1);
    },
    removeLastColour: (state) => {
      state.pop();
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addColor,
  addAllAssociateColours,
  addAllGradients,
  resetColoursAndGradients,
  removeIndexFromState,
  removeLastColour,
} = colorsSlice.actions;

export default colorsSlice.reducer;
